import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const { getTotalItems } = useCart();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src="/images/tff logo.png" alt="Tony's Family Farms" className="logo" />
        </Link>
        
        <div className="mobile-controls">
          <Link to="/cart" className="mobile-cart-btn" onClick={closeMenu}>
            🛒 ({getTotalItems()})
          </Link>
          <button className="hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
          <Link to="/products" className="nav-link" onClick={closeMenu}>Products</Link>
          <Link to="/cart" className="cart-link nav-link" onClick={closeMenu}>🛒 Cart ({getTotalItems()})</Link>
          
          {user ? (
            <>
              <Link to="/orders" className="nav-link" onClick={closeMenu}>My Orders</Link>
              {(user.role === 'associate' || user.role === 'admin') && (
                <Link to="/associate" className="nav-button gold" onClick={closeMenu}>Orders Panel</Link>
              )}
              {user.role === 'admin' && (
                <Link to="/admin" className="nav-button gold" onClick={closeMenu}>Admin Panel</Link>
              )}
              <span className="nav-user">Hello, {user.firstName}</span>
              <button onClick={handleLogout} className="nav-button" style={{textDecoration: 'none', display: 'inline-block'}}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-button" onClick={closeMenu}>Login</Link>
              <Link to="/register" className="nav-button" onClick={closeMenu}>Register</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;